import { Today } from '@material-ui/icons';
import {
  SET_REQUERIMENTO_PROFUNDIDADE,
  SET_COTA_MINIMA,
  SET_COTA_MAXIMA,
  SET_SINAL_COTA_MINIMA,
  SET_SINAL_COTA_MAXIMA,
  CLEAN_VALORES_COTAS,
  INSERT_COORDENADAS,
  REMOVE_COORDENADA,
  CLEAN_COORDENADAS,
  EDIT_COORDENADA,
  UPDATE_COORDENADA,
  CANCEL_EDICAO_COORDENADA,
  SET_DADOS_MAPA,
  SET_SUBSTANCIAS,
  SET_SUPERFICIARIOS,
  RESET_AREA_STATE,
  RESET_DADOS_MAPA,
  SET_MUNICIPIOS,
  SET_CHANGE_COORDS,
  UPDATE_INFORMACAO_AREA_LIVRE
} from '../actions/actionTypes';

const initialState = {
  requerimentoProfundidade: false,
  cotaMinima: '',
  cotaMaxima: '',
  sinalCotaMinima: {
    id: '',
    text: ''
  },
  sinalCotaMaxima: {
    id: '',
    text: ''
  },
  coordenadas: [],
  editarCoordenada: false,
  coordenadaEditar: null,
  dadosMapa: {
    imagemMapa: '',
    imagemLegenda: '',
    imagemSetaDirecional: '',
    imagemEscala: '',
    area: 0,
    municipios: [
      /*{
        idMunicipio: 0,
        nome: '',
        uf: '',
        nomeMunicipioUF: ''
      }*/
    ],
    descricaoLados: [
      {
        distancia: 0,
        azimute: 0,
        contraAzimute: 0,
        angulo: '',
        rumo: ''
      }
    ],
    amazoniaLegal: false,
    descricaoDatum: '',
    areaLivre: true,
    faixaFronteira: []
  },
  substancias: [],
  superficiarios: [],
  changeCoords: false
};

export const areaReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_REQUERIMENTO_PROFUNDIDADE:
      return {
        ...state,
        requerimentoProfundidade: action.newValue
      };

    case SET_COTA_MINIMA:
      return {
        ...state,
        cotaMinima: action.newValue
      };

    case SET_COTA_MAXIMA:
      return {
        ...state,
        cotaMaxima: action.newValue
      };

    case SET_SINAL_COTA_MINIMA:
      return {
        ...state,
        sinalCotaMinima: action.newValue
      };

    case SET_SINAL_COTA_MAXIMA:
      return {
        ...state,
        sinalCotaMaxima: action.newValue
      };

    case CLEAN_VALORES_COTAS:
      return {
        ...state,
        cotaMinima: '',
        cotaMaxima: '',
        sinalCotaMinima: {
          id: '',
          text: ''
        },
        sinalCotaMaxima: {
          id: '',
          text: ''
        }
      };

    case INSERT_COORDENADAS:
      return {
        ...state,
        coordenadas: [...state.coordenadas, ...action.newValue]
      };

    case EDIT_COORDENADA: {
      return {
        ...state,
        editarCoordenada: true,
        coordenadaEditar: state.coordenadas.filter(
          (x) => x.id === action.idToEdit
        )[0]
      };
    }

    case UPDATE_COORDENADA: {
      const newCoordenadas = state.coordenadas.map((x) => {
        if (x.id === action.coordenada.id) {
          return action.coordenada;
        }

        return x;
      });

      return {
        ...state,
        coordenadas: newCoordenadas,
        editarCoordenada: false,
        coordenadaEditar: null
      };
    }

    case REMOVE_COORDENADA:
      const manterEdicao =
        state.editarCoordenada &&
        action.idToRemove !== state.coordenadaEditar.id;

      return {
        ...state,
        coordenadas: state.coordenadas.filter(
          (x) => x.id !== action.idToRemove
        ),
        editarCoordenada: manterEdicao,
        coordenadaEditar: manterEdicao ? state.coordenadaEditar : null
      };

    case CLEAN_COORDENADAS: {
      return {
        ...state,
        coordenadas: [],
        editarCoordenada: false,
        coordenadaEditar: null
      };
    }

    case CANCEL_EDICAO_COORDENADA: {
      return {
        ...state,
        editarCoordenada: false,
        coordenadaEditar: null
      };
    }

    case SET_DADOS_MAPA: {
      return {
        ...state,
        dadosMapa: action.newValue
      };
    }

    case SET_SUBSTANCIAS: {
      let areaLivre = state.dadosMapa.areaLivre;
      if (state.dadosMapa.faixaFronteira.length > 0) {
        const idsLista = action.newValue.map(x => x.idTipoUso);

        const todosValidos = idsLista.every(id =>
          state.dadosMapa.faixaFronteira.includes(id)
        );

        areaLivre = todosValidos;
      }

      return {
        ...state,
        substancias: action.newValue,
        dadosMapa: {
          ...state.dadosMapa,
          areaLivre
        }
      };
    }

    case SET_SUPERFICIARIOS: {
      return {
        ...state,
        superficiarios: action.newValue
      };
    }

    case SET_MUNICIPIOS: {
      return {
        ...state,
        dadosMapa: {
          ...state.dadosMapa,
          municipios: action.newValue
        }
      }
    }

    case RESET_AREA_STATE: {
      return {
        ...initialState
      }
    }

    case RESET_DADOS_MAPA: {
      return {
        ...state,
        dadosMapa: initialState.dadosMapa
      }
    }

    case SET_CHANGE_COORDS: {
      return {
        ...state,
        changeCoords: action.newValue
      }
    }

    case UPDATE_INFORMACAO_AREA_LIVRE: {
      const dadosMapaCopy = { ...state.dadosMapa };
      dadosMapaCopy.areaLivre = action.areaLivre;
      return {
        ...state,
        dadosMapa: dadosMapaCopy
      }
    }

    default:
      return state;
  }
};
